import ArticleIcon from '@mui/icons-material/Article';
import BuildIcon from '@mui/icons-material/Build';
import HubIcon from '@mui/icons-material/Hub';
import NumbersIcon from '@mui/icons-material/Numbers';
import { Card, CardContent, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

export const Summary = ({ results, item }) => (
  <Card variant="outlined" sx={{ mb: 3 }}>
    <CardContent>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <ArticleIcon color="primary" /> Overall Summary
      </Typography>
      <Typography variant="body2" sx={{ mb: 3 }}>
        {results.summary}
      </Typography>
      <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
        {results?.transcripts_analyzed && (
          <Chip
            icon={<NumbersIcon />}
            label={`${results.transcripts_analyzed || item.qualitative_items_included?.length} Transcript(s) Analyzed`}
            size="small"
            variant="outlined"
            color="info"
            sx={{ borderRadius: '4px', py: 2 }}
          />
        )}
        {results?.total_unique_jobs && (
          <Chip
            icon={<HubIcon />}
            label={`${results.total_unique_jobs} Total Unique Jobs`}
            size="small"
            variant="outlined"
            color="info"
            sx={{ borderRadius: '4px', py: 2 }}
          />
        )}
        {results?.job_type_distribution && (
          <Tooltip
            title={
              <Box>
                <Typography variant="body2">
                  Functional: {results.job_type_distribution.functional}
                </Typography>
                <Typography variant="body2">
                  Emotional: {results.job_type_distribution.emotional}
                </Typography>
                <Typography variant="body2">
                  Social: {results.job_type_distribution.social}
                </Typography>
              </Box>
            }
          >
            <Chip
              icon={<BuildIcon />}
              label="Job Type Distribution"
              size="small"
              variant="outlined"
              color="info"
              sx={{ cursor: 'help', borderRadius: '4px', py: 2 }}
            />
          </Tooltip>
        )}
      </Stack>
    </CardContent>
  </Card>
);
